import { Toast, Dialog } from 'vant';
import wx from 'jweixin-1.6.0';
import comment from "../../util/comment"

var that;
var timer;
export default {
    setup() {
        const onClickLeft = () => history.back();
        return {
            onClickLeft,
        };
    },
    data() {
        return {
            dhInfoList: [],
            test:"0",
            exposure:{}
        };
    },

    created() {
        that = this;
        this.getExposureList();
        // setInterval(() => { //每5秒刷新一次图表
        //     this.getDhGoodsInfoList();
        // }, 5000);
    },
    
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer); //关闭
        } //利用vue的生命周期函数
    },

    methods: {
        getExposureList() {
            console.log(this.test);
            console.log(this.$route.query.memberId);
            this.$api.getExposureList({
                params: {
                    curPage: '1',
                    pageSize: '50',
                },
                success: function (res) {
                    console.log("resres", res);
                    that.dhInfoList = res.data
                }
            })
        },

        //详情
        jumpInfo(item) {
            console.log("item", item);
            this.$router.push({
                path: '/exposureDetail',
                query: {
                    exposureId : item.feedbackId,
                }
            })
        },

        //举报
        goUrl() {
            this.$router.push({
                path: '/exposureSave',
                query: {
                    memberId: this.$route.query.memberId
                }
            })
        }


    }
};
